<template>
  <span>
    <el-button type="primary" size="mini" plain @click="setVisible(true)" title="Edit">
      Edit
    </el-button>
    <el-dialog title="Edit Ingredient" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="Ingredient" prop="ingredient">
          <el-select
            v-model="form.ingredient"
            placeholder="Select an ingredient"
            allow-create
            default-first-option
            filterable
            no-data-text="No matching ingredients found."
            remote
            :remote-method="onQueryChange"
          >
            <el-option v-for="ingredient in ingredients" :key="ingredient.id" :label="`${ ingredient.title } (${ ingredient.createdAt })`" :value="ingredient.id" />
          </el-select>
        </el-form-item>
        <div class="row">
          <div class="col-12 col-lg-6">
            <el-form-item label="Measurement">
              <el-input v-model="form.amount" placeholder="Enter optional amount">
                <el-select v-model="form.unit" slot="append" placeholder="Select unit">
                  <el-option v-for="unit in units" :key="unit" :label="unit" :value="unit"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </div>
          <div class="col-12 col-lg-6">
            <el-checkbox v-model="form.required">required</el-checkbox>
          </div>
        </div>
        <el-button native-type="submit" type="primary" :loading="loading">
          Save
        </el-button>
        <el-button @click="onCancel">
          Cancel
        </el-button>
      </el-form>
    </el-dialog>
  </span>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      units: [null, 'tbsp', 'tsp', 'mg', 'g', 'ml', 'l', 'lb', 'mm', 'cm', 'cube', 'cup', 'can', 'kg'],
      ingredients: this.ingredient ? [this.ingredient.ingredient] : [],
      form: {
        amount: this.ingredient.amount,
        ingredient: this.ingredient ? this.ingredient.ingredient.id : null,
        required: this.ingredient.required,
        unit: this.ingredient.unit,
      },
      rules: {
        'ingredient': [
          { required: true, message: 'Select an ingredient.', trigger: 'blur' },
        ],
      },
    }
  },

  props: {
    ingredient: Object,
    stepId: String,
  },

  methods: {
    async onQueryChange(query) {
      if (!query) {
        this.ingredients = []
        return
      }

      try {
        var { data } = await this.$http.get('/ingredients', {
          params: { keyword: query },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.ingredients = data
    },
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          if (this.ingredient) {
            var { data } = await this.$http.put(`/recipe-ingredients/${ this.ingredient.id }`, {
              ...this.form,
              step_id: this.stepId,
            })
          } else {
            var { data } = await this.$http.post(`/recipe-ingredients`, {
              ...this.form,
              step_id: this.stepId,
            })
          }
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.setVisible(false)
        this.$refs['form'].resetFields()
        this.$emit('update')
        this.$message.success(data.message)
      })
    },
    onCancel() {
      this.setVisible(false)
      this.$refs['form'].resetFields()
    },
    setVisible(status) {
      this.dialogVisible = status
    },
  },
}
</script>

<style scoped>
.el-input .el-select {
  width: 14rem;
}
</style>
